<template>
  <div>
    <div v-if="noShipping === false">
      <div v-if="noProvide === false" class="rp-shipping">
        <div class="rp-shipping-detail">
          <span v-if="shippingType === '1'">{{ t.offerFreeShippingType }} {{ shippingName }}</span>
          <span v-else-if="shippingType !== '1' && freeShippingOver !== ''">{{ t.offerFreeShippingType }} {{ shippingName }} {{ t.offerFreeShippingOver }} {{ freeShippingOver | numberFormat | currency }}</span>
          <span v-if="estimatedTime !== '' && estimatedTime !== null">{{ estimatedTime }}</span>
        </div>
      </div>
      <div v-else>
        <div class="rp-shipping-detail">
          <span>{{ t.noProvide }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { Cart } from '@/store/Cart'

export default {
  name: 'Shipping',
  data () {
    return {
      freeShippingOver: '',
      estimatedTime: '',
      noProvide: false,
      noShipping: true,
      shippingType: '',
      shippingName: ''
    }
  },
  props: {
    member: {
      type: Number,
      default: 0
    },
    memberCountry: {
      type: String,
      default: 'TH'
    }
  },
  computed: {
    t () {
      if (Cart.getLocale() == 'en') {
        return {
          offerFreeShippingType: 'Free shipping by ',
          offerFreeShippingOver: ' on order over ',
          noProvide: 'No provide shipping to your country.'
        }
      } else if (Cart.getLocale() == 'th') {
        return {
          offerFreeShippingType: 'ฟรีค่าจัดส่งแบบ ',
          offerFreeShippingOver: ' เมื่อสั่งซื้อสินค้ามากกว่า ',
          noProvide: 'ไม่มีการจัดส่งไปยังประเทศของคุณ'
        }
      } else if (Cart.getLocale() == 'vi') {
        return {
          offerFreeShippingType: 'Giao hàng miễn phí bởi ',
          offerFreeShippingOver: ' Giao hàng miễn phí cho đơn hàng trên ',
          noProvide: 'Hiện chúng tôi chưa giao hàng đến quốc gia của bạn.'
        }
      }
    }
  },
  filters: {
    currency (value) {
      if (value === '-') {
        return value
      } else {
        return Cart.getCurrency(value)
      }
    },
    numberFormat (value) {
      if (value === '-') {
        return value
      } else {
        return Cart.setNumberFormat(value)
      }
    }
  },
  methods: {
    getShipping () {
      Cart.getShippingAllRegionCountryAPI().then(result => {
        let data = result.data
        if (data.shipping_region.length <= 0) {
          this.noShipping = true
        } else {
          this.noShipping = false
        }
        this.checkRegion(data)
        if (data.shipping_region.length > 0) {
          this.checkOfferFree(data)
        } else {
          this.noProvide = true
        }
      })
    },
    checkRegion (data) {
      let region = data.shipping_region
      let countRegion = Object.keys(data.shipping_region).length
      if (countRegion > 0) {
        for (let i = countRegion - 1; i >= 0; i--) {
          if (region[i].status === '1') {
            if (region[i].all_country === '0') {
              let country = region[i].country
              let hasCountry = false
              for (let x = 0; x < country.length; x++) {
                if (country[x].code === data.client_country) {
                  hasCountry = true
                  let shippingItem = region[i].shipping_item
                  for (let m = 0; m < shippingItem.length; m++) {
                    if (shippingItem[m].status === '1') {
                      break
                    } else {
                      if (m === (shippingItem.length - 1)) {
                        shippingItem.splice(m, 1)
                      }
                    }
                  }
                } else {
                  if (x === (country.length - 1) && hasCountry === false) {
                    region.splice(i, 1)
                  }
                }
              }
            }
          } else {
            region.splice(i, 1)
          }
        }
        data.shipping_region = region
      }
      return data
    },
    checkOfferFree (data) {
      let region = data.shipping_region
      let hasShippingItem = false
      for (let i = 0; i < region.length; i++) {
        let shippingItem = region[i].shipping_item

        if (this.shippingType === '1') {
          break
        }

        for (let x = 0; x < shippingItem.length; x++) {
          if (shippingItem[x].status === '1') {
            this.noShipping = false
            hasShippingItem = true
            this.shippingType = shippingItem[x].shipping_type_id
            if (shippingItem[x].shipping_type_id === '1') {
              this.shippingName = shippingItem[x].name
              this.freeShippingOver = shippingItem[x].offer_free_shipping_rate
              this.estimatedTime = shippingItem[x].estimate_time
              break
            } else {
              if (shippingItem[x].offer_free_shipping_status === '1' && shippingItem[x].offer_free_shipping_rate !== null) {
                if (parseFloat(shippingItem[x].offer_free_shipping_rate) < parseFloat(this.freeShippingOver) || this.freeShippingOver === '') {
                  this.shippingName = shippingItem[x].name
                  this.freeShippingOver = shippingItem[x].offer_free_shipping_rate
                  this.estimatedTime = shippingItem[x].estimate_time
                }
              }
            }
          }
        }
      }

      if (hasShippingItem === false) {
        this.noShipping = true
      }
    }
  },
  created () {
    Cart.setMemberShipping(this.member, this.memberCountry)
  },
  mounted () {
    this.$nextTick(() => {
      this.getShipping()
    })
  }
}
</script>

<style lang="scss" scoped>
.rp-shipping {
  display: flex;

  .rp-icon {
    display: inline-block;
    vertical-align: top;
    margin: 5px 10px 0px 0px;
  }
  .rp-shipping-detail {
    display: inline-block;
    span {
      display: block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shipping/index.vue